// @flow
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { GET_WEATHER } from './constants';
import { getConfig } from '~/core/state/config/selectors';
import type { GetWeatherAction } from './types';
import { getWeather as getWeatherApi } from '~/core/api/weather';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import { noop } from 'lodash/fp';
import { receivedWeather } from './actions';

export function* getWeatherSaga({
    payload: { postcode, countryCode }
}: GetWeatherAction): Generator<Effect | noop, *, *> {
    if (!postcode || !countryCode) {
        return;
    }

    const overrideCode = yield select(getConfig, 'weather:countryCode');
    const [weather, error] = yield call(handleApi(getWeatherApi), postcode, overrideCode || countryCode);
    yield put(receivedWeather(error || weather));
}

function* watchGetWeatherSaga(): Generator<Effect, *, *> {
    yield takeLatest(GET_WEATHER, handleSaga(getWeatherSaga));
}

export default [watchGetWeatherSaga];



// WEBPACK FOOTER //
// ./src/core/state/weather/sagas.js